import LegalPage from '@/components/feature/LegalPage';
import { websiteTerms } from '@/data/legal/websiteTerms';

export default function WebsiteTerms() {
  return <LegalPage doc={websiteTerms} />;
}